<template>
    <div class="success-revision d-flex align-items-center justify-content-center p-4" style="min-height: 400px;">
        <b-card no-body class="shadow-sm border-0 w-100 text-center" style="max-width: 600px;">
            <b-card-body class="p-5">
                <div class="mb-4 text-success">
                    <i :class="type === 'accepted' ? 'ri-award-fill' : 'ri-checkbox-circle-fill'" style="font-size: 5rem;"></i>
                </div>
                
                <template v-if="type === 'accepted' && confirmationMessage">
                    <div v-html="confirmationMessage"></div>
                </template>
                <template v-else>
                    <h4 class="font-weight-bold mb-3">{{ titleText }}</h4>
                    <p class="text-muted mb-4" style="font-size: 1.1rem; line-height: 1.6;">
                        {{ descriptionText }}
                    </p>
                </template>

                <div class="mt-4" v-if="type === 'revision'">
                    <b-button variant="outline-primary" class="px-5" @click="$emit('close')">
                        {{ $t('ok') }}
                    </b-button>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConstantService from "@/services/ConstantService";
import qs from "qs";

export default {
    name: "SuccessRevision",
    props: {
        type: {
            type: String,
            default: 'revision' // 'revision' veya 'accepted'
        }
    },
    data() {
        return {
            confirmationMessage: null
        }
    },
    mounted() {
        if (this.type === 'accepted') {
            this.getConfirmationMessage();
        } else {
            // Revizyon başarılıysa 5 saniye sonra otomatik logout
            setTimeout(() => {
                this.$store.dispatch('bisepApplication/logout')
            }, 5000);
        }
    },
    computed: {
        titleText() {
            return this.type === 'accepted' 
                ? this.$t('application_accepted_title') 
                : this.$t('documents_uploaded_successfully');
        },
        descriptionText() {
            return this.type === 'accepted' 
                ? this.$t('application_accepted_desc') 
                : this.$t('missing_documents_uploaded_desc');
        }
    },
    methods: {
        getConfirmationMessage() {
            const config = {
                params: {
                    'key': 'bisep_application.confirmation_message'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.confirmationMessage = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    }
}
</script>
